module.exports = __webpack_public_path__ + "static/for-lease-for-sale-e2f8001760161be577bc19563964ea93.svg";